export default [
  { name: 'home',
    path: '/',
    redirect: '/dashboard',
    meta: { title: 'Dashboard' }
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: () => import('@app/pages/dashboard/DashboardPage.vue'),
    meta: { title: 'Dashboard' },
  },
  {
    name: 'feedback',
    path: '/feedback',
    component: () => import('@app/pages/feedback/FeedbackPage.vue'),
    meta: { title: 'Feedback' },
  },
  {
    name: 'migration-info',
    path: '/migration-info',
    component: () => import('@app/pages/migration/MigrationInfoPage.vue'),
    meta: { title: '' },
  },
  {
    name: 'new-app',
    path: '/new-app',
    component: () => import('@app/pages/new-app/NewAppPage.vue'),
    meta: { title: '' },
  },
]